import { render, staticRenderFns } from "./Transferts.vue?vue&type=template&id=484567b8&scoped=true"
import script from "./Transferts.vue?vue&type=script&lang=ts"
export * from "./Transferts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484567b8",
  null
  
)

export default component.exports